import AnalyticsClass from "./AnalyticsClass"

//Instantiate the analytics class and export the singleton #buzz #words #microservice
const Analytics = new AnalyticsClass()
export default Analytics
